import { render, staticRenderFns } from "./studentAttendanceInfo.vue?vue&type=template&id=55319d52&"
import script from "./studentAttendanceInfo.vue?vue&type=script&lang=js&"
export * from "./studentAttendanceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports